import { useMemo } from "react";
import { ConfigProvider, Descriptions, Tag, Flex, Typography } from "antd";

import EmployeeProfile from "@/components/cards/EmployeeProfile";

import { formateDate, getPluralizedWord } from "@/utils";

import { STATUS_OPTIONS } from "@/constants/sprints";

const getStatusIcon = (color) => {
  return STATUS_OPTIONS.find((item) => item.value === color)?.icon;
};

const InfoSection = ({ data }) => {
  const durationStatus = useMemo(() => {
    if (!data) return null;

    const duration = Math.floor(data.time_in_current_status_sec / 86400); // секунды в дне

    if (duration <= 0) return "менее дня";

    return `${duration} ${getPluralizedWord(duration, [
      "день",
      "дня",
      "дней",
    ])}`;
  }, [data]);

  return (
    <Flex vertical gap={15}>
      <ConfigProvider
        theme={{
          components: {
            Descriptions: {
              itemPaddingBottom: 10,
            },
          },
        }}
      >
        <Descriptions
          column={1}
          colon={false}
          styles={{
            label: {
              width: 130,
            },
          }}
        >
          <Descriptions.Item label="Статус:">
            <Flex align="center" gap={10}>
              <Tag
                icon={getStatusIcon(data.status.style_key)}
                color={data.status.style_key}
                className="tag-with-icon-color"
              >
                {data.status.name}
              </Tag>
              <Typography.Text type="secondary">
                ({durationStatus})
              </Typography.Text>
            </Flex>
          </Descriptions.Item>
          <Descriptions.Item label="Автор:">
            <EmployeeProfile
              {...data.author}
              fullName={false}
              avatarSize={24}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Дата начала:">
            {formateDate(data.start_date)}
          </Descriptions.Item>
          <Descriptions.Item label="Дата окончания:">
            {formateDate(data.end_date)}
          </Descriptions.Item>
          <Descriptions.Item label="Рабочая группа:">
            {data.unit.name}
          </Descriptions.Item>
        </Descriptions>
      </ConfigProvider>
    </Flex>
  );
};

export default InfoSection;
